import { css as _css } from "@emotion/core";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import { ChevronRightIconSmall } from '@domain-group/fe-co-icon';
import DivisionGroup from './division-group';
import * as styles from './district-group.style';
import * as commonStyles from './common.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var DistrictGroup = props => ___EmotionJSX("div", null, props.sections.map((item, idx) => {
  var index = idx;
  return ___EmotionJSX("div", {
    key: index,
    css: styles.districtGroupSection
  }, item.title && index > 0 && ___EmotionJSX("h4", {
    css: styles.groupSectionTitle
  }, item.title), item.title && ___EmotionJSX("h4", {
    css: commonStyles.groupBrowseHeading
  }, item.title), item.newListings && ___EmotionJSX("a", {
    css: /*#__PURE__*/_css([styles.newListings, ...(item.districts[0] && item.districts[0].name ? [styles.newListingsWithMargin] : [])]),
    href: item.newListings.href
  }, ___EmotionJSX("div", {
    css: styles.newListingsTitle
  }, ___EmotionJSX("span", {
    css: /*#__PURE__*/_css([styles.newListingsTitleIndicator, ...(item.newListings.showIndicator ? [] : [styles.newListingsTitleIndicatorHidden])])
  }), ___EmotionJSX("span", {
    css: styles.newListingsTitleText
  }, item.newListings.title)), ___EmotionJSX("div", {
    css: styles.newListingsArrow
  }, ___EmotionJSX("span", {
    css: styles.newListingsArrowText
  }, "View"), ___EmotionJSX("span", {
    css: styles.newListingsArrowIconContainer
  }, ___EmotionJSX(ChevronRightIconSmall, {
    css: styles.newListingsArrowIcon,
    theme: "allhomes"
  }))), ___EmotionJSX("div", {
    css: styles.newListingsSubtitle
  }, item.newListings.subtitle)), ___EmotionJSX("div", {
    css: styles.districtGroupItems
  }, item.districts.map(district => ___EmotionJSX(DivisionGroup, _extends({
    key: district.name,
    isCollapsable: !!district.name
  }, district)))));
}));
DistrictGroup.propTypes = {
  sections: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    districts: PropTypes.arrayOf(PropTypes.shape(DivisionGroup.propTypes)),
    newListings: PropTypes.shape({
      title: PropTypes.string.isRequired,
      subtitle: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
      showIndicator: PropTypes.boolean
    })
  }))
};
DistrictGroup.defaultProps = {
  sections: []
};
export default DistrictGroup;